import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function sliderResults() {
  new Swiper('.swiper-materials', {
    modules: [Navigation],
    centeredSlides: true,
    grabCursor: true,
    initialSlide: 1,
    loop: true,
    spaceBetween: 24,
    slidesPerView: 1.01,
    navigation: {
      nextEl: ".materials__slider .swiper-button-next",
      prevEl: ".materials__slider .swiper-button-prev",
    },
    breakpoints: {
      1110: {
        slidesPerView: 1.35,
        allowTouchMove: false,
      }
    }
  });
}
sliderResults();